import React from 'react';
import type { ButtonHTMLAttributes, CSSProperties, FC } from 'react';
// import 'react-confirm-alert/src/react-confirm-alert.css';
import '../../node_modules/react-confirm-alert/src/react-confirm-alert.css'

import '../constants/const.css';
import { showMessage } from './appPane';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  confirmMessage?: string;
  btnClassName?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  style?: CSSProperties;
}

const Button: FC<ButtonProps> = ({ confirmMessage, btnClassName, style, children, onClick, ...rest }) => {
  const defaultStyle: CSSProperties = {
    cursor: 'pointer',
  };

  const styleByBtnClassName: CSSProperties = {
    backgroundImage:
      btnClassName && /post/.test(btnClassName) ? 'linear-gradient(to bottom, var(--post-button-light-color), var(--post-button-dark-color))' : defaultStyle.backgroundColor,
    border: btnClassName && /post/.test(btnClassName) ? 'none' : defaultStyle.border,
    boxShadow: btnClassName && /post/.test(btnClassName) ? '-2px 0px 4px 0px rgba(0, 0, 0, 0.5)' : defaultStyle.boxShadow,
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      if (confirmMessage) {
        showMessage({
          message: confirmMessage,
          type: 'confirm',
          onClickPositiveButton: () => onClick(e),
        });
      } else {
        onClick(e);
      }
    }
  };

  const buttonStyle: CSSProperties = {
    ...defaultStyle,
    ...styleByBtnClassName,
    ...style,
  };

  return (
    <button className={btnClassName} style={buttonStyle} onClick={handleClick} {...rest}>
      {children}
    </button>
  );
};

export default Button;
